import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { IUserData } from 'types/user';

export const useSentryContext = ({
  userData
}: {
  userData: IUserData | undefined;
}) => {
  useEffect(() => {
    if (!userData) return;
    Sentry.setUser({ email: userData.email });
    Sentry.setContext('user_context', {
      companyId: userData.companyId,
      timezone: userData.timezone,
      role: userData.role
    });
  }, [userData]);
};
